import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getAttendeesInviteesStatusQuery($orgId: ID!, $eventIds: [String!]!){
    attendeesInviteesStatus(orgId:$orgId, eventIds:$eventIds){
      fullName
      inviteeStatus
      rsvpCancelReason
    }
  }
`